<template>
    <div>
        <loader v-if="isLoading" :fullScreen="true"></loader>
        <v-container v-show="!isLoading" fluid px-4 py-0 pt-1 grid-list-lg>
            <v-layout row wrap>
                <v-flex xs12></v-flex>
                <v-flex xs12 sm6>
                    <h3>Coroner's Year To Date Report</h3>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs3>
                    <h4>Year</h4>
                </v-flex>
            </v-layout>
            <v-form ref="dateRange" v-model="formValid" @submit.prevent="loadData(searchYear)">
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-text-field clearable type="number" min="1900" max="2100" step="1" v-model="searchYear" label="Enter Year (YYYY)" required :rules="yearRules" />
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-btn :disabled="searchYear === '' || isNaN(searchYear)" type="submit" class="btn btn-primary">Search Year</v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-layout row wrap pa-2>
                <v-flex xs12>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h4>Coroner Cases Total</h4>
                            <v-data-table
                                :headers="tableHeaders"
                                :items="coronerCasesTotalList"
                                hide-actions
                                rowsPerPage="-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{props.item.name}}</td>
                                    <td>{{props.item.jan}}</td>
                                    <td>{{props.item.feb}}</td>
                                    <td>{{props.item.mar}}</td>
                                    <td>{{props.item.apr}}</td>
                                    <td>{{props.item.may}}</td>
                                    <td>{{props.item.jun}}</td>
                                    <td>{{props.item.jul}}</td>
                                    <td>{{props.item.aug}}</td>
                                    <td>{{props.item.sept}}</td>
                                    <td>{{props.item.oct}}</td>
                                    <td>{{props.item.nov}}</td>
                                    <td>{{props.item.dec}}</td>
                                    <td>{{props.item.total}}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 sm6 md2>
                            <v-btn class="btn btn-primary" :disabled="disableDownloads" @click="exportCSVFile(tableHeaders, coronerCasesTotalList, 'year_report_cases_cumulative_' + searchYear)">Download CSV</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                            <v-btn class="btn btn-primary" :disabled="disableDownloads" @click="exportPdf(coronerCasesTotalList, 'year_report_cases_' + searchYear, 'Coroner Cases')">Download PDF</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row wrap pa-2>
                <v-flex xs12>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h4>Non Jurisdictional Total</h4>
                            <v-data-table
                                :headers="tableHeaders"
                                :items="coronerCallsTotalList"
                                hide-actions
                                rowsPerPage="-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{props.item.name}}</td>
                                    <td>{{props.item.jan}}</td>
                                    <td>{{props.item.feb}}</td>
                                    <td>{{props.item.mar}}</td>
                                    <td>{{props.item.apr}}</td>
                                    <td>{{props.item.may}}</td>
                                    <td>{{props.item.jun}}</td>
                                    <td>{{props.item.jul}}</td>
                                    <td>{{props.item.aug}}</td>
                                    <td>{{props.item.sept}}</td>
                                    <td>{{props.item.oct}}</td>
                                    <td>{{props.item.nov}}</td>
                                    <td>{{props.item.dec}}</td>
                                    <td>{{props.item.total}}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                     <v-layout row wrap justify-center>
                        <v-flex xs12 sm6 md2>
                            <v-btn class="btn btn-primary" :disabled="disableDownloads" @click="exportCSVFile(tableHeaders, coronerCallsTotalList, 'year_report_calls_' + searchYear)">Download CSV</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                            <v-btn class="btn btn-primary" :disabled="disableDownloads" @click="exportPdf(coronerCallsTotalList, 'year_report_calls_' + searchYear, 'Coroner Calls')">Download PDF</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-layout row wrap pa-2>
                        <v-flex xs12>
                            <h4>Total</h4>
                            <v-data-table
                                :headers="tableHeaders"
                                :items="cumulativeTotalListValues"
                                hide-actions
                                rowsPerPage="-1">
                                <template slot="items" slot-scope="props">
                                    <td>{{props.item.name}}</td>
                                    <td>{{props.item.jan}}</td>
                                    <td>{{props.item.feb}}</td>
                                    <td>{{props.item.mar}}</td>
                                    <td>{{props.item.apr}}</td>
                                    <td>{{props.item.may}}</td>
                                    <td>{{props.item.jun}}</td>
                                    <td>{{props.item.jul}}</td>
                                    <td>{{props.item.aug}}</td>
                                    <td>{{props.item.sept}}</td>
                                    <td>{{props.item.oct}}</td>
                                    <td>{{props.item.nov}}</td>
                                    <td>{{props.item.dec}}</td>
                                    <td>{{props.item.total}}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap justify-center>
                        <v-flex xs12 sm6 md2>
                            <v-btn class="btn btn-primary" :disabled="disableDownloads" @click="exportCSVFile(tableHeaders, cumulativeTotalListValues, 'year_report_cumulative_' + searchYear)">Download CSV</v-btn>
                        </v-flex>
                        <v-flex xs12 sm6 md2>
                            <v-btn class="btn btn-primary" :disabled="disableDownloads" @click="exportPdf(cumulativeTotalListValues, 'year_report_cumulative_' + searchYear)">Download PDF</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import caseReportService from '@/services/caseReportService'
import caseService from '@/services/caseService'
import mediaService from '@/services/mediaService'
import loader from '@/components/Loader'

export default {
    name: 'DateRangeTotalsReport',
    props: {
    },
    components: {
        loader
    },
    data: function () {
        return {
            isLoading: false,
            searchDateStart: null,
            searchDateEnd: null,
            searchYear: '',
            yearRules: [
                v => !!v || 'required',
                v => (v && v >= 1970 && v <= 2100) || 'Year should be between 1970 and 2100'
            ],
            cumulativeTotalList: [],
            cumulativeTotalListValues: [],
            coronerCasesTotalList: [],
            coronerCallsTotalList: [],
            formValid: false,
            disableDownloads: true,
            tableHeaders: [
                {text: '', sortable: false, value: 'name'},
                {text: 'Jan', sortable: false, value: 'jan'},
                {text: 'Feb', sortable: false, value: 'feb'},
                {text: 'Mar', sortable: false, value: 'mar'},
                {text: 'Apr', sortable: false, value: 'apr'},
                {text: 'May', sortable: false, value: 'may'},
                {text: 'Jun', sortable: false, value: 'jun'},
                {text: 'Jul', sortable: false, value: 'jul'},
                {text: 'Aug', sortable: false, value: 'aug'},
                {text: 'Sept', sortable: false, value: 'sept'},
                {text: 'Oct', sortable: false, value: 'oct'},
                {text: 'Nov', sortable: false, value: 'nov'},
                {text: 'Dec', sortable: false, value: 'dec'},
                {text: 'Total', sortable: false, value: 'total'}
            ],
            caseTypeEnum: caseService.CaseTypeEnum,
            mannerOfDeathEnum: caseService.MannerOfDeathEnum
        }
    },
    computed: {
    },
    mounted () {
    },
    methods: {
        loadData (year) {
            this.isLoading = true
            caseReportService.generateYearToDateReport(this.$http, year).then(response => {
                this.cumulativeTotalList = response.data
                this.buildCumulativeTotalList()
                this.buildCoronerCasesTotalList()
                this.buildCoronerCallsTotalList()
                this.disableDownloads = false
                this.isLoading = false
            })
        },
        buildCumulativeTotalList () {
            this.cumulativeTotalListValues = this.getCounts(this.cumulativeTotalList)
        },
        buildCoronerCasesTotalList () {
            var list = this.cumulativeTotalList.filter(x => x.acceptedCase)
            this.coronerCasesTotalList = []
            this.coronerCasesTotalList = this.getCounts(list)
        },
        buildCoronerCallsTotalList () {
            var list = this.cumulativeTotalList.filter(x => !x.acceptedCase)
            this.coronerCallsTotalList = []
            this.coronerCallsTotalList = this.getCounts(list)
        },
        convertToCSV (objArray) {
            var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
            var str = ''

            for (var i = 0; i < array.length; i++) {
                var line = ''
                for (var index in array[i]) {
                    if (line !== '') line += ','

                    line += array[i][index]
                }

                str += line + '\r\n'
            }

            return str
        },
        convertHeadersToCsv (objArray) {
            var str = ''
            for (var i = 0; i < objArray.length; i++) {
                str += objArray[i].text
                if (i !== objArray.length - 1) str += ','
            }
            str += '\r\n'
            return str
        },
        exportPdf (list, filename, type = '') {
            this.isLoading = true
            caseReportService.generateAnnualReportPdf(this.$http, list, filename, this.searchYear, type).then(response => {
                mediaService.fileToDownload(response, filename)
                this.isLoading = false
            })
        },
        exportCSVFile (headers, items, fileTitle) {
            var csvHeaders = this.convertHeadersToCsv(headers)

            // Convert Object to JSON
            var jsonObject = JSON.stringify(items)

            var csv = csvHeaders + this.convertToCSV(jsonObject)
            console.log(csv)

            var exportedFilenmae = fileTitle + '.csv' || 'export.csv'

            var blob = new Blob([csv], { type: 'text/csvcharset=utf-8' })
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, exportedFilenmae)
            } else {
                var link = document.createElement('a')
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob)
                    link.setAttribute('href', url)
                    link.setAttribute('download', exportedFilenmae)
                    link.style.visibility = 'hidden'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }
            }
        },
        getCounts (list) {
            var returnList = []
            var suicideList = list.filter(x => x.mannerOfDeathId === this.mannerOfDeathEnum.suicide ||
                (!x.mannerOfDeathId && x.caseTypeId === this.caseTypeEnum.suicide))
            var accidentList = list.filter(x => x.mannerOfDeathId === this.mannerOfDeathEnum.accident ||
                (!x.mannerOfDeathId && x.caseTypeId === this.caseTypeEnum.accident))
            var naturalList = list.filter(x => x.mannerOfDeathId === this.mannerOfDeathEnum.natural ||
                (!x.mannerOfDeathId && x.caseTypeId === this.caseTypeEnum.natural))
            var homicideList = list.filter(x => x.mannerOfDeathId === this.mannerOfDeathEnum.homicide ||
                (!x.mannerOfDeathId && x.caseTypeId === this.caseTypeEnum.homicide))
            var pendingList = list.filter(x => x.mannerOfDeathId === this.mannerOfDeathEnum.pendingInv ||
                (!x.mannerOfDeathId && x.caseTypeId === this.caseTypeEnum.pending))
            var undeterminedList = list.filter(x => x.mannerOfDeathId === this.mannerOfDeathEnum.undetermined ||
                (!x.mannerOfDeathId && x.caseTypeId === this.caseTypeEnum.undetermined))
            returnList.push(
                {
                    name: 'Totals',
                    jan: list.filter(x => x.deathMonth === 1).length,
                    feb: list.filter(x => x.deathMonth === 2).length,
                    mar: list.filter(x => x.deathMonth === 3).length,
                    apr: list.filter(x => x.deathMonth === 4).length,
                    may: list.filter(x => x.deathMonth === 5).length,
                    jun: list.filter(x => x.deathMonth === 6).length,
                    jul: list.filter(x => x.deathMonth === 7).length,
                    aug: list.filter(x => x.deathMonth === 8).length,
                    sept: list.filter(x => x.deathMonth === 9).length,
                    oct: list.filter(x => x.deathMonth === 10).length,
                    nov: list.filter(x => x.deathMonth === 11).length,
                    dec: list.filter(x => x.deathMonth === 12).length,
                    total: list.length
                },
                {
                    name: 'Suicide',
                    jan: suicideList.filter(x => x.deathMonth === 1).length,
                    feb: suicideList.filter(x => x.deathMonth === 2).length,
                    mar: suicideList.filter(x => x.deathMonth === 3).length,
                    apr: suicideList.filter(x => x.deathMonth === 4).length,
                    may: suicideList.filter(x => x.deathMonth === 5).length,
                    jun: suicideList.filter(x => x.deathMonth === 6).length,
                    jul: suicideList.filter(x => x.deathMonth === 7).length,
                    aug: suicideList.filter(x => x.deathMonth === 8).length,
                    sept: suicideList.filter(x => x.deathMonth === 9).length,
                    oct: suicideList.filter(x => x.deathMonth === 10).length,
                    nov: suicideList.filter(x => x.deathMonth === 11).length,
                    dec: suicideList.filter(x => x.deathMonth === 12).length,
                    total: suicideList.length
                },
                {
                    name: 'Accident',
                    jan: accidentList.filter(x => x.deathMonth === 1).length,
                    feb: accidentList.filter(x => x.deathMonth === 2).length,
                    mar: accidentList.filter(x => x.deathMonth === 3).length,
                    apr: accidentList.filter(x => x.deathMonth === 4).length,
                    may: accidentList.filter(x => x.deathMonth === 5).length,
                    jun: accidentList.filter(x => x.deathMonth === 6).length,
                    jul: accidentList.filter(x => x.deathMonth === 7).length,
                    aug: accidentList.filter(x => x.deathMonth === 8).length,
                    sept: accidentList.filter(x => x.deathMonth === 9).length,
                    oct: accidentList.filter(x => x.deathMonth === 10).length,
                    nov: accidentList.filter(x => x.deathMonth === 11).length,
                    dec: accidentList.filter(x => x.deathMonth === 12).length,
                    total: accidentList.length
                },
                {
                    name: 'Natural',
                    jan: naturalList.filter(x => x.deathMonth === 1).length,
                    feb: naturalList.filter(x => x.deathMonth === 2).length,
                    mar: naturalList.filter(x => x.deathMonth === 3).length,
                    apr: naturalList.filter(x => x.deathMonth === 4).length,
                    may: naturalList.filter(x => x.deathMonth === 5).length,
                    jun: naturalList.filter(x => x.deathMonth === 6).length,
                    jul: naturalList.filter(x => x.deathMonth === 7).length,
                    aug: naturalList.filter(x => x.deathMonth === 8).length,
                    sept: naturalList.filter(x => x.deathMonth === 9).length,
                    oct: naturalList.filter(x => x.deathMonth === 10).length,
                    nov: naturalList.filter(x => x.deathMonth === 11).length,
                    dec: naturalList.filter(x => x.deathMonth === 12).length,
                    total: naturalList.length
                },
                {
                    name: 'Homicide',
                    jan: homicideList.filter(x => x.deathMonth === 1).length,
                    feb: homicideList.filter(x => x.deathMonth === 2).length,
                    mar: homicideList.filter(x => x.deathMonth === 3).length,
                    apr: homicideList.filter(x => x.deathMonth === 4).length,
                    may: homicideList.filter(x => x.deathMonth === 5).length,
                    jun: homicideList.filter(x => x.deathMonth === 6).length,
                    jul: homicideList.filter(x => x.deathMonth === 7).length,
                    aug: homicideList.filter(x => x.deathMonth === 8).length,
                    sept: homicideList.filter(x => x.deathMonth === 9).length,
                    oct: homicideList.filter(x => x.deathMonth === 10).length,
                    nov: homicideList.filter(x => x.deathMonth === 11).length,
                    dec: homicideList.filter(x => x.deathMonth === 12).length,
                    total: homicideList.length
                },
                {
                    name: 'Pending',
                    jan: pendingList.filter(x => x.deathMonth === 1).length,
                    feb: pendingList.filter(x => x.deathMonth === 2).length,
                    mar: pendingList.filter(x => x.deathMonth === 3).length,
                    apr: pendingList.filter(x => x.deathMonth === 4).length,
                    may: pendingList.filter(x => x.deathMonth === 5).length,
                    jun: pendingList.filter(x => x.deathMonth === 6).length,
                    jul: pendingList.filter(x => x.deathMonth === 7).length,
                    aug: pendingList.filter(x => x.deathMonth === 8).length,
                    sept: pendingList.filter(x => x.deathMonth === 9).length,
                    oct: pendingList.filter(x => x.deathMonth === 10).length,
                    nov: pendingList.filter(x => x.deathMonth === 11).length,
                    dec: pendingList.filter(x => x.deathMonth === 12).length,
                    total: pendingList.length
                },
                {
                    name: 'Undetermined',
                    jan: undeterminedList.filter(x => x.deathMonth === 1).length,
                    feb: undeterminedList.filter(x => x.deathMonth === 2).length,
                    mar: undeterminedList.filter(x => x.deathMonth === 3).length,
                    apr: undeterminedList.filter(x => x.deathMonth === 4).length,
                    may: undeterminedList.filter(x => x.deathMonth === 5).length,
                    jun: undeterminedList.filter(x => x.deathMonth === 6).length,
                    jul: undeterminedList.filter(x => x.deathMonth === 7).length,
                    aug: undeterminedList.filter(x => x.deathMonth === 8).length,
                    sept: undeterminedList.filter(x => x.deathMonth === 9).length,
                    oct: undeterminedList.filter(x => x.deathMonth === 10).length,
                    nov: undeterminedList.filter(x => x.deathMonth === 11).length,
                    dec: undeterminedList.filter(x => x.deathMonth === 12).length,
                    total: undeterminedList.length
                },
                {},
                {
                    name: 'County Funded Burials',
                    jan: list.filter(x => x.deathMonth === 1 && x.countyFundedBurial).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.countyFundedBurial).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.countyFundedBurial).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.countyFundedBurial).length,
                    may: list.filter(x => x.deathMonth === 5 && x.countyFundedBurial).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.countyFundedBurial).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.countyFundedBurial).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.countyFundedBurial).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.countyFundedBurial).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.countyFundedBurial).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.countyFundedBurial).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.countyFundedBurial).length,
                    total: list.filter(x => x.countyFundedBurial).length
                },
                {
                    name: 'Backwards Case***',
                    jan: list.filter(x => x.deathMonth === 1 && x.backwardsCase).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.backwardsCase).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.backwardsCase).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.backwardsCase).length,
                    may: list.filter(x => x.deathMonth === 5 && x.backwardsCase).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.backwardsCase).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.backwardsCase).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.backwardsCase).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.backwardsCase).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.backwardsCase).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.backwardsCase).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.backwardsCase).length,
                    total: list.filter(x => x.backwardsCase).length
                },
                {
                    name: 'Exhumations',
                    jan: list.filter(x => x.deathMonth === 1 && x.exhumations).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.exhumations).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.exhumations).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.exhumations).length,
                    may: list.filter(x => x.deathMonth === 5 && x.exhumations).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.exhumations).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.exhumations).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.exhumations).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.exhumations).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.exhumations).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.exhumations).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.exhumations).length,
                    total: list.filter(x => x.exhumations).length
                },
                {
                    name: 'Donor',
                    jan: list.filter(x => x.deathMonth === 1 && x.knownDonor).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.knownDonor).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.knownDonor).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.knownDonor).length,
                    may: list.filter(x => x.deathMonth === 5 && x.knownDonor).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.knownDonor).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.knownDonor).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.knownDonor).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.knownDonor).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.knownDonor).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.knownDonor).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.knownDonor).length,
                    total: list.filter(x => x.knownDonor).length
                },
                {
                    name: 'Donor Alliance',
                    jan: list.filter(x => x.deathMonth === 1 && x.isDonorAlliance).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.isDonorAlliance).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.isDonorAlliance).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.isDonorAlliance).length,
                    may: list.filter(x => x.deathMonth === 5 && x.isDonorAlliance).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.isDonorAlliance).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.isDonorAlliance).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.isDonorAlliance).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.isDonorAlliance).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.isDonorAlliance).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.isDonorAlliance).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.isDonorAlliance).length,
                    total: list.filter(x => x.isDonorAlliance).length
                },
                {
                    name: 'RM Lion Eye Bank',
                    jan: list.filter(x => x.deathMonth === 1 && x.isRMLEyeBank).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.isRMLEyeBank).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.isRMLEyeBank).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.isRMLEyeBank).length,
                    may: list.filter(x => x.deathMonth === 5 && x.isRMLEyeBank).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.isRMLEyeBank).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.isRMLEyeBank).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.isRMLEyeBank).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.isRMLEyeBank).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.isRMLEyeBank).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.isRMLEyeBank).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.isRMLEyeBank).length,
                    total: list.filter(x => x.isRMLEyeBank).length
                },
                {
                    name: 'Autopsy',
                    jan: list.filter(x => x.deathMonth === 1 && x.autopsyPerformedYnu === 1).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.autopsyPerformedYnu === 1).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.autopsyPerformedYnu === 1).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.autopsyPerformedYnu === 1).length,
                    may: list.filter(x => x.deathMonth === 5 && x.autopsyPerformedYnu === 1).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.autopsyPerformedYnu === 1).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.autopsyPerformedYnu === 1).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.autopsyPerformedYnu === 1).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.autopsyPerformedYnu === 1).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.autopsyPerformedYnu === 1).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.autopsyPerformedYnu === 1).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.autopsyPerformedYnu === 1).length,
                    total: list.filter(x => x.autopsyPerformedYnu === 1).length
                },
                {
                    name: 'Bones or Remains',
                    jan: list.filter(x => x.deathMonth === 1 && x.bonesOrRemains).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.bonesOrRemains).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.bonesOrRemains).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.bonesOrRemains).length,
                    may: list.filter(x => x.deathMonth === 5 && x.bonesOrRemains).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.bonesOrRemains).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.bonesOrRemains).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.bonesOrRemains).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.bonesOrRemains).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.bonesOrRemains).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.bonesOrRemains).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.bonesOrRemains).length,
                    total: list.filter(x => x.bonesOrRemains).length
                },
                {
                    name: 'Unidentified Bodies',
                    jan: list.filter(x => x.deathMonth === 1 && x.unidentifiedBody).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.unidentifiedBody).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.unidentifiedBody).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.unidentifiedBody).length,
                    may: list.filter(x => x.deathMonth === 5 && x.unidentifiedBody).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.unidentifiedBody).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.unidentifiedBody).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.unidentifiedBody).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.unidentifiedBody).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.unidentifiedBody).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.unidentifiedBody).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.unidentifiedBody).length,
                    total: list.filter(x => x.unidentifiedBody).length
                },
                {
                    name: 'Unclaimed Bodies',
                    jan: list.filter(x => x.deathMonth === 1 && x.unclaimedBody).length,
                    feb: list.filter(x => x.deathMonth === 2 && x.unclaimedBody).length,
                    mar: list.filter(x => x.deathMonth === 3 && x.unclaimedBody).length,
                    apr: list.filter(x => x.deathMonth === 4 && x.unclaimedBody).length,
                    may: list.filter(x => x.deathMonth === 5 && x.unclaimedBody).length,
                    jun: list.filter(x => x.deathMonth === 6 && x.unclaimedBody).length,
                    jul: list.filter(x => x.deathMonth === 7 && x.unclaimedBody).length,
                    aug: list.filter(x => x.deathMonth === 8 && x.unclaimedBody).length,
                    sept: list.filter(x => x.deathMonth === 9 && x.unclaimedBody).length,
                    oct: list.filter(x => x.deathMonth === 10 && x.unclaimedBody).length,
                    nov: list.filter(x => x.deathMonth === 11 && x.unclaimedBody).length,
                    dec: list.filter(x => x.deathMonth === 12 && x.unclaimedBody).length,
                    total: list.filter(x => x.unclaimedBody).length
                }
            )
            return returnList
        }
    }
}
</script>
